import { useSessionStore, type SessionKind } from '../stores/session/sessionStore';

/** Shared so non-component code (e.g. authRefreshScheduler) can ask the same question via getState(). */
export const isDesktopSessionKind = (kind: SessionKind): boolean => kind === 'desktop';

/**
 * Whether the current session is an Acomba desktop-bridge session.
 *
 * Only the desktop flow (sessionKind === 'desktop') has no AcceoConnect and must route sync through
 * the local Acomba bridge. Browser/portal AcombaGO sessions authenticate via AcceoConnect and must
 * NOT be gated on the bridge — so this, not the URL-derived appContext flag, is the signal that
 * drives every bridge/Acomba-only decision (sync gating, the /acomba page, the bridge icon, the
 * sync-start-date panel).
 */
export const useIsAcomba = (): boolean =>
    useSessionStore((s) => isDesktopSessionKind(s.sessionKind));
